import React from 'react';

import withApollo from 'lib/apollo';
import { useProtectedRoute } from 'lib/hooks/useProtectedRoute';

import { Dashboard } from 'components/Dashboard/Dashboard';
import { Layout } from 'components/Layout/Layout';

function DashboardPage() {
  useProtectedRoute();

  return (
    <Layout title="Dashboard">
      <Dashboard />
    </Layout>
  );
}

export default withApollo(DashboardPage);
